class MmBlogVideo extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.mm-blog-video-card__play');
    this.video = this.querySelector('.mm-blog-video-card__video');
    if (!this.button || !this.video) return;

    this.button.addEventListener('click', () => this.play());
    this.video.addEventListener('click', () => this.pause());
    this.video.addEventListener('ended', () => this.reset());
  }

  play() {
    this.video.muted = false;
    this.video.play();
    this.setAttribute('data-playing', 'true');
  }

  pause() {
    this.video.pause();
    this.removeAttribute('data-playing');
  }

  reset() {
    this.video.currentTime = 0;
    this.removeAttribute('data-playing');
  }
}

if (!customElements.get('mm-blog-video')) {
  customElements.define('mm-blog-video', MmBlogVideo);
}
